<template>
  <div>
    <h3 class="mb-5">News & Events</h3>
    <div class="h4 mb-5">
      會出現在XPG首頁的What's News區塊
    </div>

    <!-- items -->
    <PageCollapse v-for="(item, i) in bu.news_and_events" :key="i">
      <template v-slot:head>
        <h3 class="mr-auto">{{ i + 1 }}</h3>
      </template>
      <template v-slot:actions>
        <div class="ml-auto">
          <button class="btn square mr-10px" @click="deleteItem(item)">
            <v-icon class="ink-02-medium--text">delete</v-icon>
          </button>
          <button class="btn square mr-10px" @click="downItem(item, i)">
            <v-icon class="ink-02-medium--text">arrow_downward</v-icon>
          </button>
          <button class="btn square" @click="upItem(item, i)">
            <v-icon class="ink-02-medium--text">arrow_upward</v-icon>
          </button>
        </div>
      </template>
      <template v-slot:body>
        <!-- title -->
        <label class="form-item d-flex pt-3">
          <h4 class="w-180px mt-5">Title</h4>
          <div class="flex-grow-1 mt-3">
            <v-text-field
              v-model="item.title"
              outlined
              dense
            ></v-text-field>
          </div>
        </label>
        <!-- 日期 -->
        <div class="form-item d-flex pt-3">
          <h4 class="w-180px mt-5">日期</h4>
          <div class="flex-grow-1 flex-basis-0 my-n2 d-flex">
            <v-menu
              v-model="dateMenu[i]"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="item.published_at"
                  placeholder="請選擇日期"
                  outlined
                  dense
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="item.published_at"
                @input="dateMenu = false"
              ></v-date-picker>
            </v-menu>
          </div>
        </div>
        <!-- img uploader -->
        <div class="d-flex px-5 pt-5 mb-8">
          <div class="w-180px">
            <h4 class="mb-10px">Visual</h4>
            <div class="h5 ink-02-medium--text">
              建議尺寸：<br />
              ADATA: 無此功能 <br />
              XPG: 1000 px X 1000 px <br/>
              檔案大小限制：&lt; 1 MB
            </div>
          </div>
          <div class="d-flex justify-end flex-grow-1">
            <ImgUploader
              :imageUrl.sync="item.visual"
              dir="news_and_events"></ImgUploader>
          </div>
        </div>
        <!-- 通用導連網址 -->
        <label class="form-item pt-5 d-flex">
          <div class="w-180px">
            <h4 class="mb-10px">通用導連網址</h4>
            <div class="h5 ink-02-medium--text">
              若指定下方關聯News, 則此網址設定值無效
            </div>
          </div>
          <div class="flex-grow-1 flex-basis-0 my-n2">
            <v-text-field
              v-model="item.url"
              placeholder="請輸入導連網址"
              prepend-inner-icon="mdi-link"
              outlined
              dense
            ></v-text-field>
          </div>
        </label>
        <!-- 顯示/隱藏 -->
        <label class="form-item pt-5 d-flex">
          <div class="w-180px">
            <h4 class="mb-10px">顯示/隱藏</h4>
          </div>
          <div class="flex-grow-1 flex-basis-0">
            <FormSwitch v-model="item.status"></FormSwitch>
          </div>
        </label>
        <!-- 關聯News -->
        <div class="d-flex pa-5">
          <label for="filterTitleAdd" class="w-180px">
            <h4 class="mb-10px">關聯 News</h4>
          </label>
          <div class="d-flex my-n2 flex-grow-1">
            <div class="flex-grow-1">
              <v-autocomplete
                  :items="news"
                  v-model="item.news"
                  placeholder="搜尋News"
                  item-value="id"
                  item-text="title"
                  style="background: white;"
                  return-object
                  outlined
                  dense
                >
                </v-autocomplete>
            </div>
          </div>
        </div>
      </template>
    </PageCollapse>

    <!-- add What's News -->
    <div class="mt-5">
      <button class="btn btn-outlined w-100 justify-start" @click="addItem">
        <v-icon class="primary--text mr-2">add_circle</v-icon>
        <span>添加Event</span>
      </button>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import ImgUploader from '@/components/ImgUploader.vue';
import PageCollapse from '@/components/PageCollapse.vue';
import FormSwitch from '@/components/FormSwitch.vue';

export default {
  props: {
    bu: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    dateMenu: false,
    news: [],
  }),
  async created() {
    this.news = await this.getCases();
  },
  components: {
    ImgUploader,
    FormSwitch,
    PageCollapse,
  },
  methods: {
    ...mapActions('bupage', ['getCases']),
    addItem() {
      const template = {
        id: null,
        title: '',
        published_at: null,
        visual: null,
        url: null,
      };
      this.bu.news_and_events.push(template);
    },
    deleteItem(item) {
      const index = this.bu.news_and_events.map((i) => i.id).indexOf(item.id);
      this.bu.news_and_events.splice(index, 1);
    },
    downItem(item, i) {
      // if i is last, then item become the first index
      if (i === this.bu.news_and_events.length - 1) {
        this.bu.news_and_events.splice(i, 1);
        this.bu.news_and_events.unshift(item);
        return;
      }
      // item become next index
      this.bu.news_and_events.splice(i, 1);
      this.bu.news_and_events.splice(i + 1, 0, item);
    },
    upItem(item, i) {
      // if i = 0, then item go to the last one
      if (i === 0) {
        this.bu.news_and_events.splice(i, 1);
        this.bu.news_and_events.push(item);
        return;
      }
      // item become previous index
      this.bu.news_and_events.splice(i, 1);
      this.bu.news_and_events.splice(i - 1, 0, item);
    },
  },
};
</script>

<style></style>
